/**
 *
 * DetailPageLoadingEl
 *
 */
import { Grid } from '@mui/material';
import React, { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { PageHeader, SectionHeader } from '../Headers';

interface Props {}

export const DetailPageLoadingEl = memo((props: Props) => {
  return (
    <>
      <PageHeader
        text={<Skeleton width={80} />}
        icon={<Skeleton width={50} height={50} />}
      />
      <SectionHeader title={<Skeleton width={80} />} />
      <Grid container spacing={2}>
        {Array(3)
          .fill(0)
          .map((_d, i) => {
            return (
              <React.Fragment key={i}>
                <Grid item lg={4} xs={12}>
                  <Skeleton height={56} />
                </Grid>
                <Grid item lg={4} xs={12}>
                  <Skeleton height={56} />
                </Grid>
                <Grid item lg={4} xs={12}>
                  <Skeleton height={56} />
                </Grid>
              </React.Fragment>
            );
          })}
      </Grid>
    </>
  );
});
